<template>
  <div>
    <Header/>
    <Navigationzj/>
    <div class="new_detail w1200" v-loading="qyloading">
      <div class="center">
        <div class="show">
          <div class="float_l left">
            <img src="http://www.qdkeyue.com/uploads/image/20190625/1561480598.jpg">
          </div>
          <div class="float_r right">
            <div class="name">测试系统维修</div>
            <div class="fl">测试数据维修</div>
            <div class="jianjie">
              <p>测试数据维修</p>
            </div>
            <div class="lx">
              <div class="float_l erweima">
                <img src="../../assets/images/zp_17.png">
              </div>
              <div class="float_l dh">
                <div class="h6">扫一扫关注我们</div>
                <p>400-040-7890</p>
              </div>
              <div class="clear"></div>
            </div>
            <div class="button">
              <router-link :to="{path:'/'}" class="float_l xyp_l">
                <p>上一个</p>
              </router-link>
              <router-link :to="{path:'/'}" class="float_r xyp_r">
                <p>下一个</p>
              </router-link>
              <div class="clear"></div>
            </div>
          </div>
          <div class="clear"></div>
        </div>
        <div class="xqjs">详细介绍</div>
        <div class="text">
          测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修测试数据维修
        </div>
        <div class="button">
          <router-link :to="{path:'/'}" class="fanhui">返回列表</router-link>
        </div>
        <div class="tuijian">
          <div class="biaoti">
            <div class="float_l">推荐服务</div>
            <router-link class="float_r" :to="{path:'/'}">MORE+</router-link>
            <div class="clear"></div>
          </div>
          <div id="marquee1" class="marqueeleft">
            <div style="width:8000px;">
              <ul>
                <li v-for="(item,index) in 8" :key="index">
                  <router-link :to="{path:'/'}" class="float_l">
                    <div class="img">
                      <img src="http://www.qdkeyue.com/uploads/image/20190625/1561480598.jpg">
                      <div class="zhezhao">
                        <div class="h4">主轴电机维修</div>
                        <div class="h5">主轴电机维修</div>
                        <div class="p"><p></p></div>
                      </div>
                    </div>
                    <div class="h6">主轴电机维修</div>
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import Navigationzj from '@/components/Navigationzj'

export default {
  name: 'Faster',
  components: {
    Header,
    Navigationzj,
    Footer
  },
  inject: ['reload'], // 注入依赖
  data () {
    return {
    }
  },
  watch: {
    $route (to, from) {
      this.reload()
    }
  },
  mounted () {
    this.getDetail()
  },
  methods: {
    getDetail () {
    }
  }
}
</script>
<style scoped>
.clear {
  clear: both;
}
.center {
  width: 1200px;
  margin: 0 auto;
}
.new_detail .show {
  padding-bottom: 60px;
}
.new_detail .show .left {
  width: 600px;
  height: 450px;
}
.new_detail .show .left img {
  width: 600px;
  height: 450px;
}
.new_detail .show .right {
  width: 600px;
  height: 450px;
  position: relative;
}
.float_l {
  float: left;
}
.float_r {
  float: right;
}
.new_detail .show .right .name {
  font-size: 24px;
  color: #232323;
  width: 560px;
  margin-left: 40px;
  line-height: 45px;
  padding-top: 11px;
}
.new_detail .show .right .fl {
  font-size: 14px;
  color: #949494;
  width: 560px;
  margin-left: 40px;
  line-height: 30px;
}
.new_detail .show .right .jianjie {
  width: 560px;
  margin-left: 40px;
  padding-top: 18px;
}
.new_detail .show .right .jianjie p {
  font-size: 14px;
  color: #646464;
  line-height: 36px;
  text-align: justify;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.new_detail .show .right .lx {
  padding-top: 30px;
}
.new_detail .show .right .lx .erweima {
  padding: 11px;
  background: #1a6dba;
  margin-left: 40px;
}
.new_detail .show .right .lx .erweima img {
  width: 127px;
  height: 127px;
}
.new_detail .show .right .lx .dh {
  padding-left: 30px;
}
.new_detail .show .right .lx .dh .h6 {
  font-size: 16px;
  color: #646464;
  line-height: 34px;
  padding-top: 28px;
  margin-bottom: 15px;
}
.new_detail .show .right .lx .dh p {
  font-size: 34px;
  color: #1a6dba;
  font-weight: 600;
  text-indent: 58px;
  height: 40px;
  line-height: 40px;
  background: url(../../assets/repair/dianhuan.png) left center no-repeat;
}
.new_detail .show .right .button {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}
.new_detail .show .right .button a {
  width: 50%;
  height: 60px;
}
.new_detail .button a {
  width: 580px;
  height: 69px;
  background: #222222;
  display: block;
  transition: all 0.3s ease-in-out;
}
.new_detail .show .right .button a p {
  width: 52px;
  padding-left: 21px;
  line-height: 60px;
  height: 60px;
  color: #b2b2b2;
  font-size: 16px;
  margin: auto;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.new_detail .button .xyp_l p {
  transition: all 0.3s ease-in-out;
  background: url(../../assets/repair/list_show_l1.png) left center no-repeat;
}
.new_detail .show .right .button .xyp_r p {
  width: 52px;
  padding-left: 0;
  padding-right: 21px;
  background: url(../../assets/repair/list_show_r1.png) right center no-repeat;
}
.new_detail .show .right .button a p {
  transition: all 0.3s ease-in-out;
  width: 52px;
  padding-left: 21px;
  line-height: 60px;
  height: 60px;
  color: #b2b2b2;
  font-size: 16px;
  margin: auto;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.new_detail .button a:hover {
  background: #1a6dba;
}
.new_detail .button .xyp_l:hover p {
  background: url(../../assets/repair/list_show_l2.png) left center no-repeat;
}
.new_detail .show .right .button a:hover p {
    color: #fff;
}
.new_detail .show .right .button .xyp_r:hover p {
  background: url(../../assets/repair/list_show_r2.png) right center no-repeat;
}
.new_detail .xqjs {
  height: 70px;
  line-height: 70px;
  background: #1a6dba;
  font-size: 18px;
  color: #ffffff;
  padding-left: 30px;
  margin-bottom: 10px;
}
.new_detail .text {
  padding: 20px 30px 30px 30px;
}
.new_detail .button .fanhui {
  width: 180px;
  height: 56px;
  background: #1a6dba;
  border-radius: 56px;
  font-size: 16px;
  color: #fffefe;
  text-align: center;
  line-height: 56px;
  margin: auto;
  margin-bottom: 27px;
  margin-top: 40px;
  transition: all 0.3s ease-in-out;
}
.new_detail .button a {
  width: 580px;
  height: 69px;
  background: #222222;
  display: block;
  transition: all 0.3s ease-in-out;
}
.tuijian .biaoti {
  border-bottom: solid 1px #cccccc;
  margin-bottom: 32px;
}
.tuijian .biaoti .float_l {
  font-size: 24px;
  color: #2e2e2e;
  line-height: 50px;
  padding-left: 31px;
  background: url(../../assets/repair/list_icon.png) left center no-repeat;
}
.tuijian .biaoti .float_r {
  font-size: 14px;
  color: #646464;
  line-height: 50px;
}
.marqueeleft {
  width: 100%;
  overflow: hidden;
  padding-bottom: 38px;
}
.marqueeleft ul {
  float: left;
}
.marqueeleft li {
  float: left;
  display: inline;
  width: 285px;
  height: 270px;
  overflow: hidden;
  margin-right: 20px;
}
.marqueeleft li .img {
  width: 285px;
  height: 214px;
  overflow: hidden;
  position: relative;
}
.marqueeleft li .img img {
  width: 285px;
  height: 214px;
}
.marqueeleft li .img .zhezhao {
  position: absolute;
  top: 0;
  left: -285px;
  width: 285px;
  height: 214px;
  background: rgba(0, 0, 0, 0.7);
  transition: all 0.3s ease-in-out;
}
.marqueeleft li .img .zhezhao .h4 {
  font-size: 18px;
  color: #ffffff;
  text-align: center;
  padding-top: 50px;
}
.marqueeleft li .img .zhezhao .h5 {
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  padding-top: 12px;
}
.marqueeleft li .img .zhezhao .p {
  width: 102px;
  height: 34px;
  border-radius: 3px;
  display: block;
  background: #1a6dba;
  display: flex;
  align-items: center;
  margin: auto;
  margin-top: 160px;
  transition: all 0.5s ease-in-out;
}
.marqueeleft li .img .zhezhao .p p {
  width: 17px;
  height: 17px;
  margin: auto;
  background: url(../../assets/repair/service_icon.png) center center no-repeat;
}
.marqueeleft li .h6 {
  text-align: center;
  line-height: 55px;
  height: 55px;
  font-size: 14px;
  color: #646464;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.marqueeleft li:hover .img .zhezhao {
  left: 0;
}
.marqueeleft li:hover .img .zhezhao .p {
  margin-top: 28px;
}
</style>



// WEBPACK FOOTER //
// src/view/repair/repair_detail.vue